import API from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IResponse, IListResponse, IAccount, ITeamUser } from '@umu/umu-types';

export interface IPKTeamUsersParams {
    course_id: string;
    accounts: IAccount[];
    team_id?: string;
    size?: number;
}

// 获取课程PK团队打平的成员列表
export const getCoursePKTeamUsers = async (
    input: IPKTeamUsersParams,
): Promise<IResponse<{ list: ITeamUser[]; not_in_access_list: IAccount[]; page_info: IPageInfo }>> => {
    const param = {
        ...input,
        page: 1,
        size: input.size || 1000,
    };
    // if (!param.team_id) {
    //     delete param.team_id;
    // }
    return await fetchData(API.GET_COURSE_PK_TEAM_USERS, JSON.stringify(param));
};

interface IFullParams {
    course_id: string;
    accounts: IAccount[];
    team_id?: string;
}
// 获取课程PK团队带结构的成员列表
export const getCoursePKTeamStructureUsers = (input: IFullParams): Promise<IListResponse<IAccount>> => {
    const param = input;
    // if (!param.team_id) {
    //     delete param.team_id;
    // }
    return fetchData(API.GET_COURSE_PK_TEAM_STRUCTURE_USERS, JSON.stringify(param));
};
